import { LazyImage } from '@components/common/image'

const IMAGE_PATH = '/images/competitions/banners/'

type Props = {
  redirectLink: string
}

const AlgoLongBanner = ({ redirectLink }: Props) => (
  <a href={redirectLink} className="shadow-lg rounded-lg">
    <div className="relative cursor-pointer">
      <LazyImage
        alt="algorithm course long add banner"
        name="algo-long-banner"
        path={IMAGE_PATH}
        className="rounded-md"
      />
      <div className="absolute flex flex-col justify-between top-0 h-full">
        <div>
          <LazyImage
            alt="codingal logo"
            name="cg-dark-logo"
            path={IMAGE_PATH}
            className="w-24 mx-auto mt-5 mb-3"
          />
          <h3 className="font-700 text-center text-xl md:text-lg leading-5 mx-auto mb-1 px-3">
            Win the IOI by mastering Data Structures and Algorithms
          </h3>
          <p className="font-600 text-center">Grade 9-12</p>
        </div>
        <div className="pb-1 flex flex-col justify-center">
          <button
            className="btn bg-orange text-lg text-center text-white hover:bg-orange-500 py-2 px-4 mx-auto mb-1 border-none"
            style={{
              filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2))',
            }}
          >
            Try a free lesson
          </button>
          <p className="font-600 text-center text-white">
            Limited slots available
          </p>
        </div>
      </div>
    </div>
  </a>
)

export default AlgoLongBanner
